import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import DashboardPage from './pages/DashboardPage';
import InvoicesPage from './pages/InvoicesPage';
import BillsExpensesPage from './pages/BillsExpensesPage';
import BankAccountsPage from './pages/BankAccountsPage';
import OtherRecordsPage from './pages/OtherRecordsPage';
import BankReconciliationPage from './pages/BankReconciliationPage';
// import JournalPage from './pages/JournalPage';
import ChartOfAccountsPage from './pages/ChartOfAccountsPage';
import BankReconciliationPageBasiq from './bank/bank-reconcile/basiq/BankReconciliationPageBasiq';

const AccountingRouter = () => (
  <Routes>
    <Route path="dashboard" element={<DashboardPage />} />
    <Route path="invoices" element={<InvoicesPage />} />
    <Route path="bills-expenses" element={<BillsExpensesPage />} />
    {/* <Route path="bank-accounts" element={<BankAccountsPage />} /> */}
    <Route path="other-records" element={<OtherRecordsPage />} />
    <Route path="bank-reconcile" element={<BankReconciliationPage />} />
     <Route path="bank-reconcile-basiq" element={<BankReconciliationPageBasiq />} />
    {/* <Route path="journal" element={<JournalPage />} /> */}
    <Route path="chart-of-accounts" element={<ChartOfAccountsPage />} />
    <Route path="*" element={<Navigate to="dashboard" replace />} />
  </Routes>
);

export default AccountingRouter;
